import * as React from 'react';
import S from './AccordionList.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import AccordionContent from '@stories/Components/AccordionContent/AccordionContent';
const AccordionList = ({ accordion, title, variant, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(SectionWrapper, { variant: variant ?? 'black' },
            React.createElement(S.Grid, null,
                React.createElement(S.TitleArea, null, title && React.createElement(S.Title, null, title)),
                React.createElement(S.ContentArea, null,
                    React.createElement(AccordionContent, { key: `${title}-accordion`, items: accordion.items }))))));
};
export default AccordionList;
